<template>
<!-- Wrapper, because `.form-radio-group` has its own margin -->
<div>
  <div class="form-radio-group">
    <label
      v-for="featureValue in feature.values"
      :key="featureValue.key"
      class="custom-radio"
    >
      <span class="custom-radio-label">{{ featureValue.name }}</span>
      <input
        type="radio"
        :value="featureValue.id"
        v-model="valueAccessor"
      />
      <span class="radio-button"></span>
    </label>
  </div>
</div>
</template>

<script>
import AbstractFeatureField from './AbstractFeatureField'

export default AbstractFeatureField.extend({
  props: {
    value: String,
  },
})
</script>
